import React, { Component, useEffect, useState } from 'react';
import OrderMerchantsView from './OrderMerchantsView'
import crmservices from '../../wsclient/';
import {setOrderCache,order_key,getOrderCache} from '../../utils/order_cache';
import t from '../../utils/translateUtil';
import { dataUtil, preferences_type } from '../../wsclient/crmservices/dataUtil';
import { domainName, portal_config } from '../../../portal.config';
import { sortCartByProductName } from '../../utils/common';
function OrderMerchantsController(props){
            
    const [currentLocation, setCurrentLocation] = useState(null);
    const [showLoading, onShowLoading] = useState(true);
    const [showMerchantNearYou, onShowMerchantNearYou] = useState(false);
    const [stores, setStores] = useState([]);
    const [locationCheckTimer, setLocationChecTimer] = useState(null);
    const [initialRegion, setInitRegion] = useState({
        lat: 35.157322,
        lng: 33.313751
    });
    const [isRunning,setGetLocationStatus ] = useState('start');
    const [message, setMessage] = useState({});
    const [storeSelected, setStoreSelected] = useState(null);
    //filter 
    const [merchants, setMerchants] = useState([]);
    const [filter_options, setFilterOptions] = useState({
        industries: [{ id: "All", name: "All" }],
    });
    const [filterSelected, setFilterSelected] = useState({
        industry: [{ id: "All", name: "All" }],
    });
    const [showFilter, setShowFilter] = useState(false);
    const [isSelectedFilter, setIsSelectedFilter] = useState(false);
    const [params, setParams] = useState({});
    const [filters, setFilters] = useState(null);

    useEffect(() => {
        onLoad();
    },[])

    useEffect(()=>{
        if(isRunning=='start'){
            let locationCheckTimer = setInterval(() => getLocation(), 500)
            setLocationChecTimer(locationCheckTimer)
        }
        else{
            stopCheckingLocation()
        }
        return()=>clearInterval(locationCheckTimer);
    },[isRunning])

    useEffect(()=>{
        if(currentLocation){
            if(portal_config && portal_config[domainName].isOrderWithFilterMerchant) onCompareMerchants();
            else getStores();
            getRegion(currentLocation);
        }
    },[currentLocation])

    const onLoad = async () => {
        if(portal_config && portal_config[domainName].isOrderWithFilterMerchant) await getIndustries();
    }

    const getLocation = async() =>{
        await navigator.geolocation.getCurrentPosition((location) => {
            console.log("AAAAA location:",location);
            var currentLocation = {
                lat: 35.157322,
                lng: 33.313751
            }
            setCurrentLocation(currentLocation)
            stopCheckingLocation();
        }, (err) => {
            console.log('getLocation err', err)
            onShowLoading(false);
            stopCheckingLocation();
        }, {
            timeout: 5000,
            enableHighAccuracy: false
        });
    }
    const stopCheckingLocation = () =>{
        setGetLocationStatus('stop');
        if (locationCheckTimer) {
            clearInterval(locationCheckTimer);
        }
    }

    const onLoadFavouriteShop = async() =>{
        try {
            var result = await crmservices.contacts.getContactPreferences();
            console.log("onLoadFavouriteShop result:",result);
            if (result.code == 'OK') {
                setOrderCache(order_key.order_favourite_shop, result.data && result.data.organisations ? result.data.organisations : []);
            }
        } catch (error) {
            console.log('load favourite shop exception:', error);
        }
    }
    const addFavouriteShop = async(shop) =>{
        onShowLoading(true);
        try {
            var result = await crmservices.contacts.addContactPreferences(shop.id);
            if (result.code == 'OK') {
                await onLoadFavouriteShop();
            }else{
                props.showMessage(true, t('EXCEPTION_PROCESS'));
            }
        } catch (error) {
            console.log('add favourite shop exception:', error);
            props.showMessage(true, t('EXCEPTION_PROCESS'));
        }
        onShowLoading(false);
    }

    const getRegion = (location) =>{
        if (location && location.lat && location.lon) {
            var region = {
                lat: Number(location.lat),
                lng: Number(location.lon)
            }
            setInitRegion(region)
        }
    }
    const getStores = async() =>{
        try {
            var delivery_address = getOrderCache(order_key.delivery_address);
            //console.log('delivery_address-====', delivery_address)

            var lat_lot = delivery_address.lat? delivery_address.lat + ":" + delivery_address.lon : null;
            var postal_code = delivery_address.postal_code? delivery_address.postal_code: null;
            // var result = await crmservices.rewards.getLocations({ lat: delivery_address.lat, lon: delivery_address.lon });
            var result = await crmservices.orders.orderFulfillment({ supply_method: "DELIVERY", address_id: delivery_address.id, lat_lot: lat_lot, postal_code: postal_code });
            //console.log("OrderMerchantsController result:", result);
            onShowLoading(false);
            if (result.code == 'OK') {
                // var stores = result.data.content;
                var stores = result.data.fulfilled_by;
                if (stores.length > 0)
                    setMerchants(stores);
                else {
                    setOrderCache(order_key.cart,[])
                    showMessage(true, t('FULFILL_ORDER_EMPTY_EXCEPTION'));
                }
            }
        } catch (error) {
            console.log("load merchants exception:", error);
        }
    }
    const getStoresWithFilterMerchant = async() =>{
        let stores = [];
        try {
            var delivery_address = getOrderCache(order_key.delivery_address);
            var lat_lot = delivery_address.lat? delivery_address.lat + ":" + delivery_address.lon : null;
            var postal_code = delivery_address.postal_code? delivery_address.postal_code: null;
            var result = await crmservices.orders.orderFulfillment({ supply_method: "DELIVERY", address_id: delivery_address.id, lat_lot: lat_lot, postal_code: postal_code });
            if (result.code == 'OK') {
                stores = result.data.fulfilled_by ? result.data.fulfilled_by : [];
            }
            else {
                setOrderCache(order_key.cart,[])
                showMessage(true, t('FULFILL_ORDER_EMPTY_EXCEPTION'));
            }
        } catch (error) {
            console.log("load merchants exception:", error);
        }
        setStores(stores);
        return stores;
    }
    
    const onSelectMerchant = async (store) =>{
        getRegion(store.address);
        await setOrderCache(order_key.delivery_fulfilled_by,store);
        if(props.onReloadMenuItems){
            props.onReloadMenuItems()
        }
        props.onClose('open_menu');
    }
    const showMessage = (status, message) => {
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null
        });
    }

    const onShowFilterMerchants = () => {
        setShowFilter(true);
    }

    const onCloseFilter = async () => {
        setShowFilter(false);
        if(isSelectedFilter){
            await onFilterMerchants();
        }
    }

    const onFilterMerchants = async () => {
        onShowLoading(true);
        var _params = { ...params }
        _params.page = 1;
        _params = getFilterParamByType("industry", "industries", _params);
        await onCompareMerchants(_params);
        setParams(_params);
        onShowLoading(false);
    }

    const getFilterParamByType = (selectedType, paramType, params, _filterSelectedList) => {
        if(!_filterSelectedList){
            _filterSelectedList = filterSelected;
        }
        var _filterSelected = _filterSelectedList[selectedType];
        if (_filterSelected.length > 0 && _filterSelected[0].id != 'All') {
            params[paramType] = "";
            for (var i = 0; i < _filterSelected.length; i++) {
                if (i == _filterSelected.length - 1) {
                    params[paramType] = params[paramType] + _filterSelected[i].id;
                } else {
                    params[paramType] = params[paramType] + _filterSelected[i].id + ",";
                }
            }
        }
        else {
            delete params[paramType]
        }
        return params;
    }

    const onSelectFilter = async (type, value) => {
        var _filter_options = {...filters};
        var _filterSelected = {...filterSelected};
        if (value.id === 'All') {
            _filterSelected[type] = [{ id: "All", name: "All" }];            
        }
        if (_filterSelected[type].length == 1 && _filterSelected[type][0].id == 'All') {
            _filterSelected[type].splice(0, 1);
        }
        let index = -1;
        for (var i = 0; i < _filterSelected[type].length; i++) {
            if (_filterSelected[type][i].id === value.id) {
                index = i;
                break;
            }
        }
        if (index >= 0) {
            let filterSelectedByType = [..._filterSelected[type]];
            filterSelectedByType.splice(index, 1);
            _filterSelected[type] = filterSelectedByType;
        }
        else {
            _filterSelected[type].push(value);
        }
        if (_filterSelected[type].length == 0) {
            _filterSelected[type] = [{ id: "All", name: "All" }]
        }

        console.log("_filterSelected_:",_filterSelected)

        setFilters(_filter_options);
        setFilterSelected(_filterSelected);
        setIsSelectedFilter(true);
    }

    const getIndustries = async () => {
        var content = [];
        try {
            var result = await crmservices.config.getIndustries();
            if (result.code == 'OK') {
                content = result.data && result.data.content ? result.data.content : [];
                filter_options.industries = [{id: "All", name: "All"}, ...content.sort(sortCartByProductName)];
            }
        } catch (error) {
            console.log("get industries error:", error);
        }
        await setFilterOptions(filter_options);
    }

    const onGetOrgNetwork = async (param) => {
        let orgNetworks = [];
        try{
            let result = await crmservices.rewards.getOrgLocations(param);
            console.log("result getOrgLocations ===", result);
            if(result.code === 'OK'){
                if(result.data && result.data.content) orgNetworks = result.data.content;
            }
        }catch(ex){
            console.log("onGetOrgNetwork exception ===", ex);
        }
        return orgNetworks;
    }

    const onCompareMerchants = async (_params) => {
        onShowLoading(true)
        let listStores = [];
        if(stores && stores.length > 0){
            listStores = stores;
        }else{
            listStores = await getStoresWithFilterMerchant();
        }
        if(listStores && listStores.length > 0){
            let orgNetworks = await onGetOrgNetwork(_params);
            console.log("listStores AAAA===", listStores);
            console.log("orgNetworks AAAA===", orgNetworks);
            let listMerchants = dataUtil.compareMerchants(listStores, orgNetworks);
            console.log("listMerchants ===", listMerchants);
            if (listMerchants.length > 0) {
                setMerchants(listMerchants);
            } else {
                setMerchants([]);
                showMessage({ status: true, message: 'FULFILL_ORDER_EMPTY_EXCEPTION' });
            }
        }else{
            setMerchants([]);
            showMessage({ status: true, message: 'FULFILL_ORDER_EMPTY_EXCEPTION' });
        }
        onShowLoading(false)
    }
    console.log("filter_options ===", filter_options);
    return (
        <OrderMerchantsView
            showLoading={showLoading}
            message={message}
            open={props.open}
            onClose={()=>props.onClose()}
            initialRegion={initialRegion}
            stores={merchants}
            order_favourite_shop={dataUtil.filterContactPreferencesByType(getOrderCache(order_key.order_favourite_shop),preferences_type.order)}showFilter={showFilter}
            filter_options={filter_options}
            filterSelected={filterSelected}
            onSelectMerchant={onSelectMerchant}
            addFavouriteShop={addFavouriteShop}
            showMessage={showMessage}
            onShowFilterMerchants={onShowFilterMerchants}
            onCloseFilter={onCloseFilter}
            onSelectFilter={onSelectFilter}
        />
    );
}

export default OrderMerchantsController;